import { Button, Divider, Form, Input, message, Modal, Select, Upload } from "antd";
import { useEffect, useMemo, useState } from "react";
import DeleteIcon from "../../../../components/icons/DeleteIcon";
import { formatBytes, isValidURL } from "../../../../common/helpers";
import { AddBrandProduct, UpdateBrandProduct, updateUploadBrandDoc, uploadBrandDoc, uploadBrandMandatoryFile } from "../../../../API/endpoints/Brands";
import UploadIconRounded from "../../../../components/icons/UploadIconRounded";
import FileIconLarge from "../../../../components/icons/FileIconLarge";
import { updateUploadProductDoc, uploadProductDoc } from "../../../../API/endpoints/Products";
import { STATUS_REQUESTED } from "../../../../constants/constants";
import { validateAlphaNumericWithSpecialCharsAndLetters, validateAlphaNumericWithSpecialCharsAndLettersOptional } from "../../../../common/validators";

interface Props {
    open: boolean;
    editData?: any;
    onCancel: () => void;
    onSuccess: (data: any) => void;
    brand: any,
    isProduct: boolean;
    title: string;
    products: any[];
    isTodo?: boolean
}
const UploadProductAssetModal = (props: Props) => {
    const { editData, open, onSuccess, brand, isProduct, title, products, isTodo } = props;
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const [submitLoading, setSubmitLoading] = useState(false);

    const [fileList, setFileList] = useState<any>([]);





    useEffect(() => {
        if (editData && Object.keys(editData).length > 0) {
            if (isTodo) {
                form?.setFieldsValue({
                    name: editData?.sub_title,
                    description: editData?.message,
                })
            } else {
                let file: any[] = [];
                if (editData.path) {
                    file = [
                        {
                            uid: `-1`,
                            name: editData?.file_name,
                            url: editData.path,
                        }
                    ]
                }

                setFileList(file)
                form?.setFieldsValue({
                    product: editData?.product_id,
                    name: editData?.file_name,
                    description: editData?.description,
                    file: file
                })
            }

        }
    }, [editData])



    const handleChange = ({ fileList: newFileList }: any) => {
        const latestFile = newFileList[newFileList.length - 1];


        if (latestFile?.originFileObj && latestFile.originFileObj.size > 10 * 1024 * 1024) {
            messageApi.error("File size exceeds 10MB. Please upload a smaller file.");
            return;
        }

        const updatedList = newFileList.slice(-1);
        setFileList(updatedList);
        form.setFieldsValue({ file: updatedList });
    };


    const onDeleteFile = () => {
        setFileList([]);
        form.resetFields(["file"])
    }

    const onSubmit = () => {
        form.validateFields().then((values: any) => {
            setSubmitLoading(true);
            if (isTodo) {

                if (editData?.upload_field == "non mandatory") {
                    const req = new FormData();
                    req.append("brand_id", brand?.id);
                    if (values?.file[0]?.originFileObj) {
                        req.append("file", values?.file[0]?.originFileObj);
                    }
                    req.append("file_name", values?.name);
                    req.append("file_type", "Brand Assets");
                    req.append("service", "1");
                    if (values?.description) {
                        req.append("description", values?.description);
                    }

                    req.append("todo_id", editData?.id);
                    uploadBrandDoc(req).then((res: any) => {
                        if (editData?.id) {
                            onSuccess({ id: editData?.id })
                        } else {
                            onSuccess(res?.data)
                        }

                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                } else {
                    const req = new FormData();
                    if (values?.file[0]?.originFileObj) {
                        req.append("file", values?.file[0]?.originFileObj);
                    }
                    req.append("brand_id", editData?.brand_id);
                    req.append("field", editData?.upload_field);
                    req.append("todo_id", editData?.id);
                    uploadBrandMandatoryFile(req).then((res: any) => {
                        onSuccess({ id: editData?.id })
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                }


            } else if (isProduct) {
                const req = new FormData();
                req.append("product_id", values?.product);
                if (values?.file[0]?.originFileObj) {
                    req.append("file", values?.file[0]?.originFileObj);
                }
                req.append("file_name", values?.name);
                req.append("file_type", "Product Assets");
                req.append("service", "1");
                if (values?.description) {
                    req.append("description", values?.description);
                }

                if (editData && Object.keys(editData).length > 0 && editData?.status !== STATUS_REQUESTED) {
                    updateUploadProductDoc(editData?.id, req).then((res: any) => {
                        onSuccess(res?.data)
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                } else {
                    uploadProductDoc(req).then((res: any) => {
                        onSuccess(res?.data)
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                }
            } else {
                const req = new FormData();
                req.append("brand_id", brand?.id);
                if (values?.file[0]?.originFileObj) {
                    req.append("file", values?.file[0]?.originFileObj);
                }
                req.append("file_name", values?.name);
                req.append("file_type", "Brand Assets");
                req.append("service", "1");
                if (values?.description) {
                    req.append("description", values?.description);
                }

                if (editData && Object.keys(editData).length > 0 && editData?.status !== STATUS_REQUESTED) {
                    updateUploadBrandDoc(editData?.id, req).then((res: any) => {
                        onSuccess(res?.data)
                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                } else {
                    uploadBrandDoc(req).then((res: any) => {
                        if (editData?.id) {
                            onSuccess({ id: editData?.id })
                        } else {
                            onSuccess(res?.data)
                        }

                        onReset();
                        setSubmitLoading(false);
                    }).catch((err) => {
                        console.error('err', err);
                        setSubmitLoading(false);
                    })
                }
            }


        })
    }


    const normFile = (e: any) => {

        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };

    const onCancel = () => {
        props?.onCancel();
        onReset()
    }

    const onReset = () => {
        form.resetFields();
        setFileList([])
    }


    return (
        <Modal
            width={500}
            open={open}
            onCancel={() => onCancel()}
            classNames={{
                content: "!p-0 h-[calc(100vh-40px)] flex flex-col",
                header: "!px-[20px] !pt-[16px] !pb-[10px] !my-0 bg-white",
                body: "!px-[20px] !py-[12px] bg-[#F9FAFB] flex-1 overflow-auto",
                footer: "!px-[20px] !py-[12px] !mt-0",

            }}
            className="h-[calc(100% - 40px)] top-[20px] right-[20px] absolute pb-0"
            title={(
                <p className="m-0 font-[500] text-[14px]">
                    {isTodo ? "Upload Document" : editData && Object.keys(editData).length > 0 ? `Edit ${title}` : `Add ${title}`}
                </p>
            )}
            okText={"Save"}
            cancelButtonProps={{
                type: 'text',
                className: "text-[#667085]"
            }}
            okButtonProps={{
                loading: submitLoading
            }}
            onOk={() => onSubmit()}
        >
            <Form layout="vertical" requiredMark={false} form={form}>
                {contextHolder}
                <div className="grid grid-cols-1 gap-[16px]">
                    {isProduct ? (
                        <Form.Item
                            name="product"
                            label="Product"
                            rules={[{ required: true }]}
                        >

                            <Select
                                placeholder="Select product"
                                options={products}
                                fieldNames={{ label: "name", value: "id" }}
                            />
                        </Form.Item>
                    ) : (
                        <></>
                    )}

                    <Form.Item
                        name="name"
                        label="Document / File Name"
                        rules={[validateAlphaNumericWithSpecialCharsAndLetters]}
                    >
                        <Input
                            type="text"
                            placeholder="Document / File Name"
                            disabled={isTodo}
                        />
                    </Form.Item>
                    <Form.Item
                        name="description"
                        label="Description"
                        rules={[validateAlphaNumericWithSpecialCharsAndLettersOptional]}
                    >
                        <Input.TextArea
                            placeholder="Description"
                            disabled={isTodo}

                        />
                    </Form.Item>
                    <Form.Item
                        hidden={fileList.length > 0}
                        name={"file"}
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                        rules={[{ required: true, message: "File required" }]}
                    >
                        <Upload
                            listType="picture"
                            className="w-full upload-form-item"
                            fileList={fileList}
                            onChange={handleChange}
                            beforeUpload={(file) => {
                                return false
                            }}
                            showUploadList={false}
                        >
                            <div className="flex w-full gap-x-[10px] items-center border border-[#E4E7EC] p-[12px] rounded-[6px] cursor-pointer bg-white hover:!bg-[#F9FAFB]">
                                <UploadIconRounded />
                                <div className="flex-1">
                                    <p className="mb-[4px] text-[13px] font-[500]">Upload Document</p>
                                </div>
                            </div>
                        </Upload>
                    </Form.Item>

                    {fileList.length > 0 ? (
                        <div className="flex gap-x-[10px] items-center border border-[#E4E7EC] p-[12px] rounded-[6px] bg-white">
                            <FileIconLarge />
                            <div className="flex-1">
                                <p className="mb-[4px] text-[13px] font-[500]">{fileList[0]?.name}</p>
                                <p className="text-[12px] text-[#475467] m-0">{fileList[0]?.size ? formatBytes(fileList[0]?.size) : ""}</p>
                            </div>
                            <Button icon={<DeleteIcon color="#475467" />} type="text" onClick={() => onDeleteFile()} />
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </Form>

        </Modal>
    )
}

export default UploadProductAssetModal